import useStores from './use-stores';
/**
 * @returns {(msg?: string, type?: 'danger' | 'error' | 'info' | 'success', timeout?: number, reasonCode?: string) => void}
 */ export default function useErnie() {
    var _stores_UI;
    var stores = useStores();
    return stores === null || stores === void 0 ? void 0 : (_stores_UI = stores.UI) === null || _stores_UI === void 0 ? void 0 : _stores_UI.showErnie;
}
